import ToolShell, { OutputBlock } from "@/pages/tools/ToolShell";

const DAYS = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];

export default function ContentPlan() {
  return (
    <ToolShell
      testid="tool-plan-page"
      eyebrow="Tool" toolKey="plan"
      title="2-Week Content Plan"
      subtitle="Fourteen days, mixed archetypes and CTAs, balanced for compounding reach."
      endpoint="/tools/content-plan"
      fields={[
        { key: "focus", label: "Focus or theme (optional)", type: "text", placeholder: "e.g. Launching a buoyancy course in 14 days" },
      ]}
      renderOutput={(o) => (
        <>
          <OutputBlock testid="output-focus" label="Focus">{o.focus || "Balanced growth"}</OutputBlock>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {(o.days || []).map((d) => (
              <div key={d.day} className="dms-card p-5" data-testid={`plan-day-${d.day}`}>
                <div className="flex items-center justify-between mb-2">
                  <span className="text-[11px] tracking-[0.22em] uppercase font-bold text-[#1D4E89]">Day {d.day} · {DAYS[(d.day - 1) % 7]}</span>
                  <span className="dms-badge">{d.format}</span>
                </div>
                <h3 className="font-heading font-bold text-[16px] text-[#0A2342]">&ldquo;{d.hook}&rdquo;</h3>
                <p className="mt-2 text-[14.5px] text-[#475569] leading-relaxed">{d.concept}</p>
                <div className="mt-3 flex flex-wrap gap-2 text-[11px] tracking-[0.18em] uppercase font-bold text-[#64748B]">
                  <span>{d.hook_archetype}</span>
                  <span>·</span>
                  <span>{d.psychological_trigger}</span>
                  <span>·</span>
                  <span>{d.cta_level}</span>
                </div>
              </div>
            ))}
          </div>
        </>
      )}
    />
  );
}
